import { render, staticRenderFns } from "./fpsChart.vue?vue&type=template&id=62607548&scoped=true&"
import script from "./fpsChart.vue?vue&type=script&lang=js&"
export * from "./fpsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62607548",
  null
  
)

export default component.exports